/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Draft_ReviewInputs */

const en_us2_today_draft_review = /** @type {(inputs: Today_Draft_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review`)
};

const pt_br2_today_draft_review = /** @type {(inputs: Today_Draft_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar`)
};

const es_419_today_draft_review = /** @type {(inputs: Today_Draft_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar`)
};

const pt_pt2_today_draft_review = /** @type {(inputs: Today_Draft_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rever`)
};

const fr_fr2_today_draft_review = /** @type {(inputs: Today_Draft_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Examiner`)
};

const de_de2_today_draft_review = /** @type {(inputs: Today_Draft_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfen`)
};

const it_it2_today_draft_review = /** @type {(inputs: Today_Draft_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivedi`)
};

/**
* | output |
* | --- |
* | "Review" |
*
* @param {Today_Draft_ReviewInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_draft_review = /** @type {((inputs?: Today_Draft_ReviewInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Draft_ReviewInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_draft_review(inputs)
	if (locale === "es-419") return es_419_today_draft_review(inputs)
	if (locale === "pt-PT") return pt_pt2_today_draft_review(inputs)
	if (locale === "fr-FR") return fr_fr2_today_draft_review(inputs)
	if (locale === "de-DE") return de_de2_today_draft_review(inputs)
	if (locale === "it-IT") return it_it2_today_draft_review(inputs)
	return en_us2_today_draft_review(inputs)
});
export { today_draft_review as "today.draft_review" }